import type { JSONSchema7 } from 'json-schema';

import AppFooterContentWidget from '../../widgets/app-footer-content-widget/schema.json';
import CasinoCompletedRacesWidget from '../../widgets/casino-completed-races-widget/schema.json';
import CasinoGameGridWidget from '../../widgets/casino-game-grid-widget/schema.json';
import CasinoGameInfoWidget from '../../widgets/casino-game-info-widget/schema.json';
import CasinoGameSliderWidget from '../../widgets/casino-game-slider-widget/schema.json';
import CasinoGameTrailerWidget from '../../widgets/casino-game-trailer-widget/schema.json';
import CasinoMosaicWidget from '../../widgets/casino-mosaic-widget/schema.json';
import CasinoMyGamesWidget from '../../widgets/casino-my-games-widget/schema.json';
import CasinoMyRewardsWidget from '../../widgets/casino-my-rewards-widget/schema.json';
import CasinoNewGamesWidget from '../../widgets/casino-new-games-widget/schema.json';
import CasinoPlayerGamesWidget from '../../widgets/casino-player-games-widget/schema.json';
import CasinoRacesWidget from '../../widgets/casino-races-widget/schema.json';
import CasinoSecondaryNavigation from '../../widgets/casino-secondary-navigation/schema.json';
import CasinoTopGamesWidget from '../../widgets/casino-top-games-widget/schema.json';
import CMSNavigationWidget from '../../widgets/cms-navigation-widget/schema.json';
import CMSPageWidget from '../../widgets/cms-page-widget/schema.json';
import CrmWidget from '../../widgets/crm-widget/schema.json';
import FirstWalletWidget from '../../widgets/first-wallet-widget/schema.json';
import FooterWidget from '../../widgets/footer-widget/schema.json';
import HeaderWidget from '../../widgets/header-widget/schema.json';
import HelpBotWidget from '../../widgets/help-bot-widget/schema.json';
import HelpCenterArticleWidget from '../../widgets/help-center-article-widget/schema.json';
import HelpCenterCategoryWidget from '../../widgets/help-center-category-widget/schema.json';
import HelpCenterHomeWidget from '../../widgets/help-center-home-widget/schema.json';
import HelpCenterSearchWidget from '../../widgets/help-center-search-widget/schema.json';
import LegacySportsWidget from '../../widgets/legacy-sports-widget/schema.json';
import NavWidget from '../../widgets/nav-widget/schema.json';
import PokerHomeGamesWidget from '../../widgets/poker-home-games-widget/schema.json';
import PokerStarsExchangeToggleWidget from '../../widgets/poker-stars-exchange-toggle-widget/schema.json';
import PokerStarsExchangeWidget from '../../widgets/poker-stars-exchange-widget/schema.json';
import SportsAnimalRacingMeetingsWidget from '../../widgets/sports-animal-racing-meetings-widget/schema.json';
import SportsAntePostEventsWidget from '../../widgets/sports-ante-post-events-widget/schema.json';
import SportsAntePostMarketWidget from '../../widgets/sports-ante-post-market-widget/schema.json';
import SportsBetSlipWidget from '../../widgets/sports-bet-slip-widget/schema.json';
import SportsBreadcrumbsWidget from '../../widgets/sports-breadcrumbs-widget/schema.json';
import SportsCmsBannerWidget from '../../widgets/sports-cms-banner-widget/schema.json';
import SportsCompetitionEventsWidget from '../../widgets/sports-competition-events-widget/schema.json';
import SportsCompetitionOutrightsWidget from '../../widgets/sports-competition-outrights-widget/schema.json';
import SportsCompetitionsWidget from '../../widgets/sports-competitions-widget/schema.json';
import SportsEventInfoWidget from '../../widgets/sports-event-info-widget/schema.json';
import SportsEventTypeInfoWidget from '../../widgets/sports-event-type-info-widget/schema.json';
import SportsEventTypeSpecialsWidget from '../../widgets/sports-event-type-specials-widget/schema.json';
import SportsFeaturedFiltersWidget from '../../widgets/sports-featured-filters-widget/schema.json';
import SportsFeaturedWidget from '../../widgets/sports-featured-widget/schema.json';
import SportsGolfMatchesWidget from '../../widgets/sports-golf-matches-widget/schema.json';
import SportsHistoricalBetsWidget from '../../widgets/sports-historical-bets-widget/schema.json';
import SportsHomeInPlayWidget from '../../widgets/sports-home-in-play-widget/schema.json';
import SportsInPlayEventsWidget from '../../widgets/sports-in-play-events-widget/schema.json';
import SportsMarketsWidget from '../../widgets/sports-markets-widget/schema.json';
import SportsMatchFilteringWidget from '../../widgets/sports-match-filtering-widget/schema.json';
import SportsMenuWidget from '../../widgets/sports-menu-widget/schema.json';
import SportsMyBetsWidget from '../../widgets/sports-my-bets-widget/schema.json';
import SportsNextRacesWidget from '../../widgets/sports-next-races-widget/schema.json';
import SportsOddsBoostWidget from '../../widgets/sports-odds-boost-widget/schema.json';
import SportsPageNotFoundWidget from '../../widgets/sports-page-not-found-widget/schema.json';
import SportsPromotionDetailsWidget from '../../widgets/sports-promotion-details-widget/schema.json';
import SportsPromotionGridWidget from '../../widgets/sports-promotion-grid-widget/schema.json';
import SportsPromotionWidget from '../../widgets/sports-promotion-widget/schema.json';
import SportsQuickLinksWidget from '../../widgets/sports-quick-links-widget/schema.json';
import SportsRaceCardWidget from '../../widgets/sports-race-card-widget/schema.json';
import SportsRaceInfoWidget from '../../widgets/sports-race-info-widget/schema.json';
import SportsRacePageWidget from '../../widgets/sports-race-page-widget/schema.json';
import SportsSelfExcludedInfoWidget from '../../widgets/sports-self-excluded-info-widget/schema.json';
import SportsSeoWidget from '../../widgets/sports-seo-widget/schema.json';
import SportsSettingsWidget from '../../widgets/sports-settings-widget/schema.json';
import SportsSportInPlayEventsWidget from '../../widgets/sports-sport-in-play-events-widget/schema.json';
import SportsUpcomingEventsWidget from '../../widgets/sports-upcoming-events-widget/schema.json';

export interface WidgetSchema extends JSONSchema7 {
  vary?: string;
  cacheControl?: string;
  hidden?: string[];
}

const schemata = {
  AppFooterContentWidget,
  CasinoCompletedRacesWidget,
  CasinoGameGridWidget,
  CasinoGameInfoWidget,
  CasinoGameSliderWidget,
  CasinoGameTrailerWidget,
  CasinoMosaicWidget,
  CasinoMyGamesWidget,
  CasinoMyRewardsWidget,
  CasinoNewGamesWidget,
  CasinoPlayerGamesWidget,
  CasinoRacesWidget,
  CasinoSecondaryNavigation,
  CasinoTopGamesWidget,
  CMSNavigationWidget,
  CMSPageWidget,
  CrmWidget,
  FirstWalletWidget,
  FooterWidget,
  HeaderWidget,
  HelpBotWidget,
  HelpCenterArticleWidget,
  HelpCenterCategoryWidget,
  HelpCenterHomeWidget,
  HelpCenterSearchWidget,
  LegacySportsWidget,
  NavWidget,
  PokerHomeGamesWidget,
  PokerStarsExchangeToggleWidget,
  PokerStarsExchangeWidget,
  SportsAnimalRacingMeetingsWidget,
  SportsAntePostEventsWidget,
  SportsAntePostMarketWidget,
  SportsBetSlipWidget,
  SportsBreadcrumbsWidget,
  SportsCmsBannerWidget,
  SportsCompetitionEventsWidget,
  SportsCompetitionOutrightsWidget,
  SportsCompetitionsWidget,
  SportsEventInfoWidget,
  SportsEventTypeInfoWidget,
  SportsEventTypeSpecialsWidget,
  SportsFeaturedFiltersWidget,
  SportsFeaturedWidget,
  SportsGolfMatchesWidget,
  SportsHistoricalBetsWidget,
  SportsHomeInPlayWidget,
  SportsInPlayEventsWidget,
  SportsMarketsWidget,
  SportsMatchFilteringWidget,
  SportsMenuWidget,
  SportsMyBetsWidget,
  SportsNextRacesWidget,
  SportsOddsBoostWidget,
  SportsPageNotFoundWidget,
  SportsPromotionDetailsWidget,
  SportsPromotionGridWidget,
  SportsPromotionWidget,
  SportsQuickLinksWidget,
  SportsRaceCardWidget,
  SportsRaceInfoWidget,
  SportsRacePageWidget,
  SportsSelfExcludedInfoWidget,
  SportsSeoWidget,
  SportsSettingsWidget,
  SportsSportInPlayEventsWidget,
  SportsUpcomingEventsWidget
} as Record<string, WidgetSchema>;

export default schemata;
